import React from "react";
import { isMobile } from "react-device-detect";

class GameSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAFavouriteGame: this.props.favouritesData.indexOf(this.props.game.id) > -1,
            justAdded: false,
            justRemoved: false
        };

        this.updateFavourites = this.updateFavourites.bind(this);
        this.onGameClick = this.onGameClick.bind(this);
        this.myRef = GBEUtils.createUUID();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.favouritesData !== this.props.favouritesData) {
            this.setState({
                isAFavouriteGame: this.props.favouritesData.indexOf(this.props.game.id) > -1
            });
        }
    }

    logClick() {

    }

    updateFavourites(isAdd, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "casino-game-selector", eventAction: "click", eventLabel: value });
        const thisComponent = this;
        const gameId = thisComponent.props.game.id;
        var favouritesPTVName = "Games.Favourites.Exchange.Web";

        if (!thisComponent.props.hideIfNotFavourite) {

            this.setState({
                isAFavouriteGame: isAdd,
                justAdded: isAdd,
                justRemoved: !isAdd
            });
        }

        if (thisComponent.props.hideIfNotFavourite && !isAdd) {
            //$("#" + this.myRef).fadeOut(1000);
        }

        const gameSelectorMessage = document.querySelectorAll(".gameSelectorMessage");
        gameSelectorMessage.forEach((element) => {
            element.style.transition = "opacity 1s";
            element.style.opacity = 0;
            setTimeout(() => {
                element.style.display = "none";
            }, 1000);
        });

        function setNewPTV(newFavourites) {
            thisComponent.props.controller.addPunterTaggedValue({
                name: favouritesPTVName,
                value: newFavourites.join("|"),
                callbackOnSuccess: function () {
                    thisComponent.props.onUpdateFavourites(newFavourites);
                },
                callbackOnException: function () {

                }
            });
        }

        thisComponent.props.controller.getPunterTaggedValue({
            name: favouritesPTVName,
            callbackOnSuccess: function (taggedValue) {

                var newFavourites = [];
                const allGames = [];

                if (taggedValue.value !== "") {

                    try {
                        newFavourites = taggedValue.value.split("|");
                    } catch (ex) {
                        console.error("existing favourties incorrect format:" + taggedValue.value);
                    }

                }

                thisComponent.props.gamesData.forEach((group) => {
                    group.games.forEach((game) => {
                        allGames.push(game);
                    });
                });

                const device = isMobile ? "mobile" : "web";

                newFavourites = newFavourites.filter(function (favGame) {
                    return thisComponent.props.gamesIndex[favGame][device].isEnabled;
                });

                if (isAdd) {
                    newFavourites.push(gameId);
                } else {

                    newFavourites = newFavourites.filter(function (aGameId) {
                        return gameId !== aGameId;
                    });
                }

                setNewPTV(newFavourites);

            },
            callbackOnException: function (errorResponse) {
                if (errorResponse.returnCode === 475) { //does not exist
                    if (isAdd) {
                        setNewPTV([gameId]);
                    }

                }

                if (errorResponse.returnCode === 512) { //does not exist
                    alert("your session has expired");
                    window.location.reload();
                }

            }
        });

    }

    onGameClick(event, value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "casino-game-selector", eventAction: "click", eventLabel: value });
        event.preventDefault();

        const isReal = event.currentTarget.getAttribute("data-isreal") === "true";
        const sameTab = isMobile;
        this.props.onPlayGame(this.props.game, isReal, sameTab);
    }

    render() {
        const game = this.props.game;
        const cdnPath = this.props.cdnLocation + "games/en/pages/";
        var gameImage = cdnPath + game.code.toLowerCase().replace(/\s/g, "%20") + (isMobile ? "_mob_thumb.gif" : "_thumb.gif");

        if (game.image) {
            if (game.image.indexOf("http") === 0) {
                gameImage = game.image;
            } else {
                gameImage = "https://bshots.egcvi.com/thumbnail" + game.image;
            }
        }

        let colName = isMobile ? "col-md-4" : "col-md-3";
        colName = this.props.colName ? this.props.colName : colName;
        return (
            <div id={this.myRef} className={"gameSelector " + colName}>
                <div className="inner" style={{ "backgroundImage": "url(" + gameImage + ")" }} >
                    {this.props.fromSearch &&
                        <a className="GamesButton" href="/playGame" data-isreal="true" onClick={(e) => this.onGameClick(e, "real-play")}></a>
                    }
                    {game.web.isNew &&
                        <div className="ribbon ribbon-top-right"><span>New</span></div>
                    }
                    {this.props.userContext !== undefined &&
                        <div style={{ "margin": "10px", "float": "left" }} >
                            {this.state.isAFavouriteGame &&
                                <a className="host-remove" title={"Remove " + game.name + " from your favourites"} onClick={this.updateFavourites.bind(this, false, "remove-game-from-fav")} >-
                                </a>
                            }
                            {!this.state.isAFavouriteGame &&
                                <a className="host-add" title={"Add " + game.name + " to your favourites"} onClick={this.updateFavourites.bind(this, true, "add-game-to-fav")} >+
                                </a>
                            }
                        </div>

                    }
                    <div style={{ "position": "absolute", "right": "37px", "top": "3px" }}>
                        {this.state.justRemoved &&
                            <span className="gameSelectorMessage">Favourite removed</span>
                        }
                        {this.state.justAdded &&
                            <span className="gameSelectorMessage">Favourite added</span>
                        }
                    </div>
                    {!this.props.fromSearch &&
                        <div className="gameSelectorFooter">

                            <a className="GamesButton" href="/playGame" data-isreal="true" onClick={(e) => this.onGameClick(e, "real-play")}>
                                <span>Real Play</span>
                            </a>
                            {(game.web.hasDemo) &&
                                <a className="GamesButtonAlt" href="/playGame" data-isreal="false" onClick={(e) => this.onGameClick(e, "fun-play")}>
                                    <span>Fun Play</span>
                                </a>
                            }

                        </div>
                    }
                </div>
                <span className="gameSelectorTitle">{game.name}</span>
            </div >

        );
    }
}

export default GameSelector;